export const listOfCountries = ["United States of America", "Canada", "United Kingdom", "Mexico"] as const;

export const NORTH_AMERICAN_COUNTRIES = ["United States of America", "Canada"];

export type CountryValue = (typeof listOfCountries)[number];

export type ShortCountryValue = ["US", "CA", "GB", "MX"][number];

export const longToShortCountries = {
	"United States of America": "US",
	Canada: "CA",
	"United Kingdom": "GB",
	Mexico: "MX",
} as Record<CountryValue, ShortCountryValue>;

export const shortToLongCountries = {
	US: "United States of America",
	CA: "Canada",
	GB: "United Kingdom",
	MX: "Mexico",
} as Record<ShortCountryValue, CountryValue>;

export function toShortCountry(longCountry?: string): ShortCountryValue | string | undefined {
	if (!longCountry) {
		return undefined;
	}

	return longToShortCountries[longCountry as CountryValue]
		? longToShortCountries[longCountry as CountryValue]
		: longCountry;
}

export function toLongCountry(shortCountry?: string): CountryValue | string | undefined {
	if (!shortCountry) {
		return undefined;
	}

	return shortToLongCountries[shortCountry as ShortCountryValue]
		? shortToLongCountries[shortCountry as ShortCountryValue]
		: shortCountry;
}

export const optionalLongCountryStringToCountryValue = (country: string | null | undefined) => {
	if (!country || !listOfCountries.includes(country as CountryValue)) {
		return undefined;
	}
	return country as CountryValue;
};

export const getCountryCurrency = (country?: string | undefined) => {
	switch (country) {
		case "Canada":
			return "CAD";
		case "United Kingdom":
			return "GBP";
		case "United States of America":
			return "USD";
		case "Mexico":
			return "MXN";
		default:
			return "USD";
	}
};

export const isCountryValue = (value: unknown): value is CountryValue => {
	return typeof value === "string" && listOfCountries.some((country) => country === value);
};
